/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tcType: NonNullable<unknown> }} Input_Tc_Set_Button_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Set timecode for {tcType}" |
*
* @param {Input_Tc_Set_Button_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_set_button_aria_label = /** @type {((inputs: Input_Tc_Set_Button_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Set_Button_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Définir le timecode pour ${i?.tcType}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Setze Zeitcode für ${i?.tcType}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Imposta il codice temporale per ${i?.tcType}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Установите временной код для ${i?.tcType}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Establecer código de tiempo para ${i?.tcType}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`设置 ${i?.tcType} 的时间码`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.tcType} のタイムコードを設定する`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.tcType} के लिए टाइमकोड सेट करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Defina o código de tempo para ${i?.tcType}`)
	return /** @type {LocalizedString} */ (`Set timecode for ${i?.tcType}`)
});